import { useState } from "react";
import { parseExcelFile } from "../../actions/importexcel";
import { useMutation } from "@tanstack/react-query";

export default function ExcelToTable() {
   const [headers, setHeaders] = useState([]);
   const [rows, setRows] = useState([]);
   var nombre = "";
   const validInsumos = ["insumo", "insumostattoo"];
   var url = process.env.REACT_APP_URL_DIR + "sqlraw/";
   const token = localStorage.getItem("token");
   const handleFileUpload = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      nombre = file.name.split(".")[0];
      console.log("file: ", nombre);
      if (!validInsumos.includes(nombre)) {
         alert(
            "Archivo no válido: solo el nombre del archivo debe ser 'insumo' o 'insumostattoo'"
         );
         return;
      }
      try {
         const { headers, rows } = await parseExcelFile(file);
         setHeaders(headers);
         setRows(rows);
      } catch (error) {
         console.error("Error reading Excel:", error);
      }
   };

   const { mutate: grabarDatos } = useMutation({
      mutationFn: (newPost) =>
         fetch(url, {
            method: "PUT",
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         console.log("Grabado");
         window.location.href = "/";
      },
      onError: () => {
         alert("Error en datos ingresados");
      },
   });

   const handleExcelUpload = async () => {
      // Aquí puedes manejar la lógica para subir el archivo a un servidor si es necesario
      console.log("Excel uploaded with headers:", headers);
      console.log("Excel uploaded with rows:", rows);
      // Aquí puedes manejar la lógica para subir el archivo a un servidor si es necesario
      var sql = "UPDATE insumo set stock = CASE id_primary ";
      var sql2 = "UPDATE insumo set dolar = CASE id_primary ";
      var sqlwhere = "where id_primary IN (";
      rows.forEach((row) => {
         if (row[0]) {
            sql += ` WHEN ${row[0]} THEN ${row[2]} `;
            sql2 += ` WHEN ${row[0]} THEN ${row[3]} `;
            sqlwhere += `${row[0]},`;
         }
      });
      sqlwhere = sqlwhere.slice(0, -1) + ")";
      sql += " END " + sqlwhere;
      sql2 += " END " + sqlwhere;
      console.log(sql);
      console.log(sql2);
      grabarDatos({ sql: sql });
      grabarDatos({ sql: sql2 });
      setHeaders([]);
      setRows([]);
   };

   return (
      <div className="p-4">
         <h1 className="text-xl font-bold mb-4">Import Excel with Headers</h1>

         <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            className="mb-4"
         />
         <button onClick={() => handleExcelUpload()}>Upload</button>
         {rows.length > 0 && (
            <table className="table-auto border-collapse border border-gray-400 w-full">
               <thead className="bg-gray-200">
                  <tr>
                     {headers.map((h, i) => (
                        <th
                           key={i}
                           className="border border-gray-400 px-2 py-1 text-left"
                        >
                           {h}
                        </th>
                     ))}
                  </tr>
               </thead>
               <tbody>
                  {rows.map((row, i) => (
                     <tr key={i}>
                        {row.map((cell, j) => (
                           <td
                              key={j}
                              className="border border-gray-400 px-2 py-1"
                           >
                              {cell}
                           </td>
                        ))}
                     </tr>
                  ))}
               </tbody>
            </table>
         )}
         <br />
         <br />
         <p style={{color:"white"}}>{`Browser inner window width: ${window.innerWidth} px`}</p>
         <br />
         <p style={{color:"white"}}>{`Browser inner window height: ${window.innerHeight} px`}</p>
      </div>
   );
}
